<div>
  <div class="fix-width p-3">
    <div *ngIf="shareObject.data.type === 'list' || shareObject.data.type === 'deleted'">
      <h1 class="fw-bold fs-4 mb-3">{{'title_call_record_manager'|translate}}</h1>
      <div *ngIf="shareObject.isLoading">
        <div class="">
          <div class="spinner-border spinner-border-sm text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div *ngIf="!shareObject.isLoading">
        <div class="mb-3" *ngIf="shareObject.phoneId"><i class="bi bi-telephone-fill"></i> {{shareObject.phoneId}}</div>
        <div class="mt-3 border-bottom">
          <!-- Search bar -->
          <div class="w-100 mb-2">
            <div class="d-flex align-items-center justify-content-between gap-2 w-100">
              <div class="d-flex align-items-center gap-2">
                <!-- button back  -->
                <span class="btn py-1 btn-sm btn-warning  rounded-1" (click)="sharedService.back()">
                  <i class="bi bi-arrow-left"></i>
                  <span class="ms-2">{{'btn_back'|translate}}</span>
                </span>
                <span *ngIf="sharedService.env.production===false" class="btn btn-sm btn-primary rounded-1"
                  [routerLink]="shareObject.addURL">
                  <i class="bi bi-plus-square"></i>
                  <span class="ms-2">{{'btn_add'|translate}}</span>
                </span>
                <!-- link to list deleted -->
                <span *ngIf="sharedService.env.production===false && shareObject.data.type === 'list' "
                  class="btn py-1 btn-sm btn-danger rounded-1" [routerLink]="shareObject.deletedURL" role="button">
                  <i class="bi bi-trash-fill"></i>
                  <span class="ms-2">{{'link_deleted'|translate}}</span>
                </span>
                <!-- soft delete  -->
                <span
                  *ngIf="sharedService.env.production===false && shareObject?.selectedRows?.size > 0 && shareObject.data.type === 'list'"
                  class="btn py-1 btn-sm btn-danger rounded-1" (click)="softDeleteItem(shareObject?.selectedRows)"
                  role="button">
                  <i class="bi bi-archive"></i>
                  <span class="ms-2">{{'btn_soft_delete'|translate}}</span>
                </span>
                <!-- restore many  -->
                <span
                  *ngIf="sharedService.env.production===false && shareObject?.selectedRows?.size > 0 && shareObject.data.type === 'deleted'"
                  class="btn py-1 btn-sm btn-success rounded-1" (click)="restoreItem(shareObject?.selectedRows)"
                  role="button">
                  <i class="bi bi-arrow-clockwise"></i>
                  <span class="ms-2">{{'btn_restore'|translate}}</span>
                </span>
                <!-- clear  -->
                <span class="btn py-1 btn-sm btn-info rounded-1" (click)="clear()" role="button">
                  <i class="bi bi-arrow-clockwise"></i>
                  <span class="ms-2">{{'btn_clear'|translate}}</span>
                </span>
                <span class="btn py-1 btn-sm btn-primary rounded-1" (click)="shareObject.filterBox = true"
                  role="button">
                  <i class="bi bi-funnel"></i>
                  <span class="ms-2"> {{'btn_filter'|translate}} </span>
                </span>
                <!-- export btn -->
                <span class="btn py-1 btn-sm btn-primary rounded-1 d-none" (click)="getUsers()">
                  <i class="bi bi-file-earmark-arrow-up"></i>
                  <span class="ms-2">{{'btn_export_file'|translate}}</span>
                </span>
              </div>
            </div>
            <!-- search box -->
            <div style="z-index: 1050; width: 600px" class="position-absolute">
              <form *ngIf="shareObject.filterBox===true" [formGroup]="filterForm"
                class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
                <div class="row g-2">
                  <!-- employee keyword -->
                  <div class="col-md-12">
                    <label class="form-label fw-bold" for="keyword">{{'filter_keyword'|translate}}</label>
                    <input type="text" class="form-control form-control-sm" formControlName="keyword" id="keyword">
                  </div>
                  <div class="col-md-12">
                    <label class="form-label fw-bold" for="phoneNumber">{{'filter_phone_number'|translate}}</label>
                    <input type="text" class="form-control form-control-sm" formControlName="phoneNumber"
                      id="phoneNumber">
                  </div>
                  <!-- page size -->
                  <div class="col-md-4">
                    <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
                    <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
                      <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">{{size}}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label fw-bold" for="date">{{'filter_start_date'|translate}}</label>
                    <input type="date" class="form-control form-control-sm" formControlName="startDate" id="startDate">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                    <input type="date" class="form-control form-control-sm" formControlName="endDate" id="endDate">
                  </div>
                  <div class="col-md-12">
                    <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                    <select class="form-select form-select-sm" formControlName="group" id="group">
                      <option value="">{{'filter_group_all'|translate}}</option>
                      <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">{{group.name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <label class="form-label fw-bold" for="type">{{'filter_call_type'|translate}}</label>
                    <select class="form-select form-select-sm" formControlName="type" id="type">
                      <option value="">{{'filter_type_all'|translate}}</option>
                      <option *ngFor="let type of shareObject.callTypes" value="{{type.id}}">{{type.name}}</option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <div class="form-check d-flex align-items-center p-0">
                      <label class="form-check-label fw-bold" for="duration">{{'filter_duration'|translate}}</label>
                      <input id="duration" formControlName="duration" class="form-check-input ms-3" type="checkbox">
                    </div>
                  </div>
                  <!-- employee keyword -->
                  <div class="col-md-3">
                    <label class="form-label fw-bold mb-4" for="btns"></label>
                    <div class=" d-flex gap-2" id="btns">
                      <button class="btn btn-primary btn-sm rounded-1"
                        (click)="onSearch()">{{'btn_filter'|translate}}</button>
                      <button class="btn btn-secondary btn-sm rounded-1"
                        (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                      <!-- <button class="btn btn-primary btn-sm rounded-1"
                      (click)="refresh()">{{'btn_clear'|translate}}</button> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- filter result -->
          <div class="d-flex gap-2 mt-2">
            <button type="button" *ngIf="shareObject.options.filter.keyword"
              class="btn btn-outline-primary btn-sm rounded-1 position-relative mb-2">
              {{shareObject.options.filter.keyword}}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                (click)="filter('keyword',undefined)" role="button">x</span>
            </button>
            <button type="button" *ngIf="shareObject.options.filter.phoneNumber"
              class="btn btn-outline-primary btn-sm rounded-1 position-relative mb-2">
              {{shareObject.options.filter.phoneNumber}}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                (click)="filter('phoneNumber',undefined)" role="button">x</span>
            </button>
            <button type="button" *ngIf="shareObject.options.filter.participant"
              class="btn btn-outline-primary btn-sm rounded-1 position-relative mb-2">
              {{shareObject.options.filter.participant}}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                (click)="filter('participant',undefined)" role="button">x</span>
            </button>
            <button type="button" *ngIf="shareObject.options.filter.group"
              class="btn btn-outline-primary btn-sm rounded-1 position-relative mb-2">
              {{shareObject.groupText}}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                (click)="filter('group',undefined)" role="button">x</span>
            </button>

            <button type="button" *ngIf="shareObject.options.filter.type"
              class="btn btn-outline-primary btn-sm rounded-1 position-relative mb-2">
              {{shareObject.typeText}}
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                (click)="filter('type',undefined)" role="button">x</span>
            </button>
          </div>
        </div>
        <div class="fix-height">
          <table class="table table-hover table-striped table-sm">
            <thead class="sticky-top bg-white">
              <tr>
                <th style="width: 50px;">
                  <div class="form-check">
                    <input class="form-check-input" role="button" type="checkbox"
                      [checked]="isAllSelected(shareObject.items)" (change)="toggleSelectAll($event,shareObject.items)"
                      id="checkall">
                    <label class="form-check-label" for="checkall"></label>
                  </div>
                </th>
                <th scope="col" style="width: 160px;">{{'call_time'|translate}}</th>
                <th scope="col" style="width: 320px;">{{'call_phone_number'|translate}}</th>
                <th scope="col" style="width: 320px;">{{'call_participant'|translate}}</th>
                <th scope="col" style="width: 150px;">{{'call_type'|translate}}</th>
                <th scope="col" style="width: 150px;">{{'call_duration'|translate}}</th>
                <th scope="col">{{'call_record'|translate}}</th>
              </tr>
            </thead>
            <tbody *ngIf="shareObject.items && shareObject.items.length > 0 && !shareObject.isLoading">
              <tr *ngFor="let item of shareObject.items; let i =index" (click)="selectRow($event, i)">
                <td>
                  <div class="form-check">
                    <!-- <input class="form-check-input" role="button" type="checkbox" (change)="checked(item.id)"
                      [checked]="item.checked" id="checkitem"> -->
                    <input class="form-check-input" role="button" type="checkbox"
                      [checked]="shareObject.selectedRows.has(i)" id="checkitem">
                    <label class="form-check-label" for="checkitem"></label>
                  </div>
                </td>
                <td>
                  <span>
                    {{item.callAtText| date:'dd/MM/yyyy HH:mm:ss'}}
                  </span>
                </td>
                <td role="button">
                  <div class="d-flex gap-2 align-items-center ">
                    <i class="bi bi-telephone-fill text-primary me-2 fs-8"></i>
                    <span class="fw-bold" *ngIf="item?.phone"
                      (click)="filter('phoneNumber',item?.phone?.number)">{{item?.phone?.number}}</span>
                    <span class="fw-bold fst-italic" *ngIf="!item?.phone">{{'phone_unknown'|translate}}</span>
                    <span class="">({{item?.phone?.holder?.profile?.name}})</span>
                  </div>
                </td>
                <td role="button">
                  <div class="d-flex gap-2 align-items-center ">
                    <i class="bi bi-search text-primary me-2 fs-8"></i>
                    <span class="fw-bold" (click)="filter('participant',item.participant)">{{item?.participant}}
                    </span>
                    <span *ngIf="item?.contact?.data?.name">({{item?.contact?.data?.name}})</span>
                    <a *ngIf="!item?.contact" class="text-decoration-none" [routerLink]="['/user/phone/contact/create']"
                      [queryParams]="{phone: item?.participant}">
                      <i class="bi bi-person-plus text-primary"></i>
                    </a>
                  </div>
                </td>
                <td>{{item?.typeText}}</td>
                <td>{{item?.duration|duration}}</td>
                <td>
                  <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'list'">
                    <span attr.data-title="{{'help_play'|translate}}" class="btn btn-sm btn-success py-0 rounded-1"
                      *ngIf="!item?.play && item?.duration>0" (click)="playAudio(item)">
                      <i class="bi bi-play-fill"></i>
                    </span>
                    <span attr.data-title="{{'help_pause'|translate}}" class="btn btn-sm btn-danger py-0 rounded-1"
                      *ngIf="item?.play" (click)="stopAudio(item)">
                      <i class="bi bi-stop-fill"></i>
                    </span>
                    <span *ngIf="sharedService.env.production === false" class="btn btn-danger btn-sm rounded-1 py-0"
                      (click)="softDeleteItem([i])">
                      <i class="bi bi-archive me-2"></i>
                      {{'btn_soft_delete'|translate}}
                    </span>
                  </div>
                  <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'deleted'">
                    <span class="btn btn-success btn-sm rounded-1 py-0" (click)="restoreItem([i])">
                      <i class="bi bi-arrow-clockwise me-2"></i>
                      {{'btn_restore'|translate}}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <caption *ngIf="shareObject.items && shareObject.items.length === 0">
              <div class="text-center">
                {{'no_phone_found'|translate}}
              </div>
            </caption>
            <caption *ngIf="shareObject.isLoading">
              <div class="text-center">
                <div class="spinner-border spinner-border-sm text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </caption>
          </table>
        </div>
        <!-- statitis -->
        <div class="d-flex mt-2">
          <span *ngFor="let item of shareObject.callTypes">
            <button *ngIf="item.count>0" (click)="filter('type',item.id )" role="button"
              class="me-2 d-flex gap-2 btn btn-sm btn-{{item.checked?'primary':'outline-primary'}} rounded-1">
              <span class="fs-7">{{item.name}}:</span>
              <span class="fw-bold fs-7">{{item.count}}</span>
            </button>
          </span>
        </div>
        <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
          (changePage)="onPageChange($event)"></app-pagination>
      </div>
    </div>
    <div *ngIf="shareObject.data.type === 'edit' || shareObject.data.type === 'add'">
      <h1 *ngIf="shareObject.data.type === 'edit'" class="fw-bold fs-4 text-uppercase mb-3">
        {{"title_edit_call_record"|translate}}
      </h1>
      <h1 *ngIf="shareObject.data.type === 'add'" class="fw-bold fs-4 text-uppercase mb-3">
        {{"title_add_call_record"|translate}}
      </h1>
      <div *ngIf="shareObject.isLoading">
        <div class="">
          <div class="spinner-border spinner-border-sm text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div *ngIf="!shareObject.isLoading">
        <form action="" [formGroup]="addForm" (ngSubmit)="onSubmit()" class="p-3 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="mb-3">
            <label for="phone" class="form-label fw-bold">{{'call_record_phone'|translate}}</label>
            <input type="text" class="form-control" id="phone" formControlName="phone"
              placeholder="{{'call_record_phone_placeholder'|translate}}">
          </div>
          <div class="mb-3">
            <label for="participant" class="form-label fw-bold">{{'call_record_participant'|translate}}</label>
            <input type="text" class="form-control" id="participant" formControlName="participant"
              placeholder="{{'call_record_participant_placeholder'|translate}}">
          </div>
          <div class="mb-3">
            <label for="type" class="form-label fw-bold">{{'call_record_type'|translate}}</label>
            <select name="type" id="type" class="form-select form-select-sm" formControlName="type">
              <option *ngFor="let type of sharedService.env.callRecordType" [value]="type.value">{{type.name |
                translate}}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="call_at" class="form-label fw-bold">{{'call_record_call_at'|translate}}</label>
            <input type="datetime-local" class="form-control" id="call_at" formControlName="callAt"
              placeholder="{{'call_record_call_at_placeholder'|translate}}">
          </div>
          <div class="mb-3">
            <label for="duration" class="form-label fw-bold">{{'call_record_duration'|translate}}</label>
            <input type="number" class="form-control" id="duration" formControlName="duration"
              placeholder="{{'call_record_duration_placeholder'|translate}}">
          </div>
          <div class="mb-3">
            <label for="record" class="form-label fw-bold">{{'call_record_file'|translate}}</label>
            <input type="file" (change)="fileChange($event)" class="form-control" id="record" formControlName="record"
              placeholder="{{'call_record_file_placeholder'|translate}}">
          </div>
          <div class="d-flex gap-2">
            <button *ngIf="shareObject.data.type=='add'" type="submit"
              class="btn btn-primary btn-sm">{{'btn_add'|translate}}</button>
            <button *ngIf="shareObject.data.type=='edit'" type="submit"
              class="btn btn-primary btn-sm">{{'btn_save'|translate}}</button>
            <span class="btn btn-warning btn-sm" (click)="sharedService.back()">{{'btn_back'|translate}}</span>
          </div>
        </form>
      </div>
    </div>

  </div>

  <div class="audio-player" *ngIf="shareObject.audio">
    <div class="d-flex bg-white shadow rounded-2 gap-3 p-3 align-items-center w-100">
      <i class="bi bi-stop-fill fs-5" attr.data-title="{{'help_stop'|translate}}" role="button"
        (click)="stopAudio(shareObject.callRecord)"></i>
      <i *ngIf="!shareObject.audio.paused" attr.data-title="{{'help_pause'|translate}}" class="ms-3 bi bi-pause-fill"
        role="button" (click)="pauseAudio(shareObject.callRecord)"></i>
      <i *ngIf="shareObject.audio.paused" attr.data-title="{{'help_play'|translate}}" class="ms-3 bi bi-play-fill"
        role="button" (click)="resumeAudio(shareObject.callRecord)"></i>
      <i class="ms-3 bi bi-cloud-download-fill" [attr.data-title]="'help_download'|translate" role="button"
        (click)="downloadAudio(shareObject.callRecord)"></i>
      <span class="time">{{ shareObject.audio.currentTime|duration:'player' }}</span>
      <input type="range" class="form-range progress-range" id="customRange1" [value]="shareObject.audio.currentTime"
        (input)="onAudioSeek($event)" (change)="onAudioSeek($event)" min="0" [max]="shareObject.audio.duration"
        step="1">
      <span class="time">{{ shareObject.audio.duration|duration:'player' }}</span>
    </div>
  </div>
</div>